export default "__VITE_ASSET__D8tM4Us7__"